// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

// ===== Interfaces =====

import {
    ISaleItem,
}                               from '../interfaces';

const getSaleItem = async ({
    test,
    paymentIntentId,
}: {
    test: boolean,
    paymentIntentId: string,
}): Promise<ISaleItem | null> => {
    const functions = getFunctions();
    const handleGetSaleItem = httpsCallable<
        Record<
            string,
            boolean | string
        >,
        ISaleItem | null
    >(
        functions,
        'getSaleItem',
    );
    return handleGetSaleItem({
        test,
        paymentIntentId,
    }).then((result) => {
        const saleItem = result.data as ISaleItem | null;
        return saleItem;
    }).catch((err) => {
        throw err;
    });
};

export default getSaleItem;
